import { AppStateFailure, IStateSlice } from '@symphony-solo/shared/common-state/src';
import { PaymentDto } from '../dtos';

export class PaymentsState implements IStateSlice {
  public isLoading: boolean;
  public failures: AppStateFailure;
  public payments: PaymentDto[];
  public selectedPayment: PaymentDto;

  constructor() {
    this.isLoading = false;
    this.failures = null;
    this.payments = null;
    this.selectedPayment = null;
  }
}
